import { createContext, useContext } from 'react';
import CategoryModal from 'component/Modal/CategoryModal';
import AddCrypto from 'component/Modal/AddNewCrypto';
import { useDashboardNav } from './useDashboardNav';

const DashboardNavContext = createContext(null);

export function DashboardNavProvider({ children }) {
  const nav = useDashboardNav();

  return (
    <DashboardNavContext.Provider value={nav}>
      <CategoryModal visible={nav.visibleCategory} setVisble={nav.setVisibleCategory} />
      <AddCrypto visible={nav.showCoin} setVisble={nav.setShowCoin} />
      {children}
    </DashboardNavContext.Provider>
  );
}

export function useDashboardNavContext() {
  const context = useContext(DashboardNavContext);
  if (!context) {
    throw new Error('useDashboardNavContext must be used within DashboardNavProvider');
  }
  return context;
}
